<template>
    <div class="Protection">
        <div class="header" :style="`background-image: url('${baseUrl}img/${productDatas.headerImg}.jpg');`">
            <!-- <img src="../../public/img/centerSlide1.jpg" width="100%" alt="" srcset=""> -->
            <div class="headerText">
                <p>{{productDatas.MainTitle}}</p>
                <p class="headerTextMini">{{productDatas.miniTitle}}</p>
            </div>
        </div>
        <div class="ProtectionProductsClassList">
            <el-row :gutter="20">
                <el-col @click.native="turnList(index)" v-for="(item, index) in ProtectionProductsClassList" :key="index" class="culture_item" :xs="24" :sm="{span:7,offset:(index%2==0?5:0)}" :md="{span:7,offset:(index%2==0?5:0)}">
                    <ProtectionProductsClass :title="item.title" :text="item.text" :img="item.img"></ProtectionProductsClass>            
                </el-col>
                <el-col class="culture_item" :xs="24" :sm="{span:7,offset:ProtectionProductsClassList.length%2==0?5:0}" :md="{span:7,offset:ProtectionProductsClassList.length%2==0?5:0}">
                    <ProtectionProductsClass :title="''" :text="''" :img="'null.jpg'"></ProtectionProductsClass>     
                </el-col>
            </el-row>
        </div>
        <foot></foot>
    </div>
</template>
<script>
import foot from "@/components/foot.vue";
import ProtectionProductsClass from "@/components/ProtectionProductsClass.vue";
import {productData} from "../datas/productData.js"

export default {
    components:{foot,ProtectionProductsClass},
    data() {
        return {
            baseUrl:process.env.BASE_URL, 
            productDatas:{
                MainTitle:'',
                miniTitle:'',
                itemList:[]
            }
        }
    },
    computed:{
        ProtectionProductsClassList(){
            return this.productDatas.itemList
        }
    },
    watch:{
        '$i18n.locale'(){
            this.getData()
        },
        '$route' (to, from) {
            this.getData()
        }
    },
    methods:{
        getData(){
            this.productDatas = productData(this.$route.params.class)
            // console.log(this.$route.params.class)
        },
        turnList(index){
            if(this.productDatas.itemList[index].child.length==1){
                this.$router.push('/productInfo/'+this.$route.params.class+'/'+index + "/" + 0)
            }else{
                this.$router.push('/product/'+this.$route.params.class+'/'+index)
            }
        }
    },
    created(){
        this.getData()
    }
}
</script>
<style lang="less">
.Protection{
    width: 100%;
    position: relative;
    .ProtectionProductsClassList{
        padding: 4rem 0;
    }
    .header{
        width: 100%;
        position: relative;
        height: 500px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;

        .headerText{
            position: absolute;
            left: 21%;
            top: 50%;
            transform: translate(0,-40%);
            color: #fff;
            font-size: 2rem;
            font-weight: bold;
            line-height: 1rem;
            letter-spacing: 0.15rem;
            .headerTextMini{
                font-size: 0.6rem;
                line-height: 0.5rem;
            }
        }
    }
}
</style>
